import { ChangeHistoryAction } from '@/api/client';
import React from 'react';

interface IProps {
  action: number;
}

const GridCellAction: React.FC<IProps> = ({ action }) => {
  return (
    <td colSpan={1} role="gridcell" aria-selected="false">
      <div>{ChangeHistoryAction[action]}</div>
    </td>
  );
};

export default GridCellAction;
